import { writable } from 'svelte/store';


export const cuenta = writable({});
export const recetaActiva = writable({});
export const documentos = writable([]);


